// import React from "react";
// import { FaArrowRightFromBracket } from "react-icons/fa6";
// import { AiOutlineInfoCircle, AiOutlineShopping } from "react-icons/ai";
// import { RiFileCopyLine, RiUserLine, RiBarChart2Line } from "react-icons/ri";
// import { NavLink } from "react-router-dom";
// import { LuUsers2 } from "react-icons/lu";

// const data = [
//   {
//     id: 1,
//     name: "Requests",
//     link: "requests",
//     icon: <FaArrowRightFromBracket />,
//   },
//   {
//     id: 2,
//     name: "Quotes",
//     link: "quotes",
//     icon: <RiFileCopyLine />,
//   },
//   {
//     id: 3,
//     name: "Orders",
//     link: "orders",
//     icon: <AiOutlineShopping />,
//   },
//   {
//     id:4,
//     name: "Dispute/Request Credit",
//     link: "support",
//     icon: <AiOutlineInfoCircle />,
//   },
//   {
//     id:5,
//     name: "Administration",
//     link: "administration",
//     icon: <RiUserLine />,
//   },
//   {
//     id:6,
//     name: "Users",
//     link: "users",
//     icon: <LuUsers2 />,
//   },
//   {
//     id:7,
//     name: "Reports",
//     link: "report",
//     icon: <RiBarChart2Line />,
//   },
// ];

// const MobileNav = ({isOpen}) => {
//   let role = localStorage.getItem("role");
//   return (
//     <div className="fixed bottom-0 z-[999] w-full px-4 py-4 bg-white shadow-2xl lg:hidden">
//       <div className="flex justify-around transition-all ">
//         {data.map((item) => {
//           const { id, name, link, icon } = item;
//           return (
//             <NavLink
//               to={link}
//               key={id}
//               className={`flex flex-col text-center items-center gap-y-1 font-semibold opacity-50 text-wrap flex-1 ${
//                   (role === "CUSTOMER" || role === "SUPPLIER") && id > 4
//                     ? "hidden"
//                     : "block"
//                 } ${
//                   (role === "ADMIN") && id < 5
//                     ? "hidden"
//                     : "block"
//                 } gap-3`}
//             >
//               <span className="text-lg">{icon}</span>
//               <span className="text-xs">{name}</span>
//             </NavLink>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// export default MobileNav;

import React from "react";
import { FaArrowRightFromBracket } from "react-icons/fa6";
import { AiOutlineInfoCircle, AiOutlineShopping } from "react-icons/ai";
import { RiFileCopyLine, RiUserLine, RiBarChart2Line } from "react-icons/ri";
import { LuUsers2 } from "react-icons/lu";
import { NavLink } from "react-router-dom";

const navItems = [
  {
    id: 1,
    name: "Requests",
    link: "requests",
    icon: <FaArrowRightFromBracket />,
    roles: ["CUSTOMER", "SUPPLIER"],
  },
  {
    id: 2,
    name: "Quotes",
    link: "quotes",
    icon: <RiFileCopyLine />,
    roles: ["CUSTOMER", "SUPPLIER"],
  },
  {
    id: 3,
    name: "Orders",
    link: "orders",
    icon: <AiOutlineShopping />,
    roles: ["CUSTOMER", "SUPPLIER"],
  },
  {
    id: 4,
    name: "Dispute / Credit",
    link: "support",
    icon: <AiOutlineInfoCircle />,
    roles: ["CUSTOMER", "SUPPLIER"],
  },
  {
    id: 5,
    name: "Accepted Requests",
    link: "orderProcess",
    icon: <AiOutlineInfoCircle />,
    roles: ["SUPPLIER"],
  },
  {
    id: 6,
    name: "Hidden Requests",
    link: "hiddenData",
    icon: <AiOutlineInfoCircle />,
    roles: ["SUPPLIER"],
  },
  {
    id: 7,
    name: "Administration",
    link: "administration",
    icon: <RiUserLine />,
    roles: ["ADMIN"],
  },
  { id: 8, name: "Users", link: "users", icon: <LuUsers2 />, roles: ["ADMIN"] },
  {
    id: 9,
    name: "Reports",
    link: "report",
    icon: <RiBarChart2Line />,
    roles: ["ADMIN"],
  },
  {
    id: 10,
    name: "Quotes",
    link: "adminquotes",
    icon: <RiFileCopyLine />,
    roles: ["ADMIN"],
  },
  {
    id: 11,
    name: "Requests",
    link: "requestApproval",
    icon: <LuUsers2 />,
    roles: ["ADMIN"],
  },
  {
    id: 12,
    name: "Flag",
    link: "flaggedComment",
    icon: <RiBarChart2Line />,
    roles: ["ADMIN"],
  },
];

const MobileNav = () => {
  const role = localStorage.getItem("role");
  return (
    <div className="fixed bottom-0 z-[999] w-full px-4 py-4 bg-white shadow-2xl lg:hidden">
      <div className="flex justify-around">
        {navItems
          .filter((item) => item.roles.includes(role))
          .map(({ id, name, link, icon }) => (
            <NavLink
              key={id}
              to={link}
              className="flex flex-col items-center gap-y-1 flex-1 font-semibold opacity-50 text-wrap"
            >
              <span className="text-lg">{icon}</span>
              <span className="text-xs">{name}</span>
            </NavLink>
          ))}
      </div>
    </div>
  );
};

export default MobileNav;
